(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name DirectoryController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('DirectoryController', DirectoryController);

    DirectoryController.$inject = ['$uibModal','$log', '$document','UserService','$timeout'];


    function DirectoryController($uibModal,$log,$document,UserService,$timeout)
    {

    	var vm = this;
    	vm.countries=[];
    	vm.comittees=[];
    	vm.directory= [] ;
    	vm.fullname="";
    	vm.company="";
    	vm.comitee ="";
    	vm.country="";
    	vm.offset = 0;
    	vm.loading = true;

        UserService.getCountries().then(function(data){
        	console.log(data);
        	vm.countries = data.countries;
        	UserService.getComittee().then(function(data){
        		console.log(data);
        		vm.comittees = data.comittee;
        	});
        });

        vm.updateDirectory = function(restart)
        {
        	if(restart){
        		vm.loading= false;
        		vm.offset = 0;
                vm.directory= [];
        	}

        	if(vm.loading)
        		return ;

        	if(vm.directory.length)
        		vm.offset++;

        	

        	vm.loading= true;
        	UserService.getDirectory(vm.country,vm.comittee,vm.fullname,vm.company,vm.offset).then(function(data){
        		console.log(data);
        		if(vm.offset>0){
        			  
        			  	$timeout(function(){

							
							vm.directory = vm.directory.concat(data.directory);
							console.log(vm.directory);
							vm.loading= false;
        			  	});
        					
      			}
        		else{
        			vm.directory = data.directory;
        			vm.loading= false;
        		}

        		
        	});
        };
        
    }

})();